import {getData, postUrlencodedData, api} from '../request';

export function getPagedNewsList(index, size, callBack){
    getData(api.getNewsList, {index: index, size: size})
        .then(res => {
            if (res.code === 200)
                callBack(res.data);
            else
                callBack(false, res.message);
        }, rej => {
            console.log(rej);
            callBack(false)
        });
}

export function deleteNews(id, callBack) {
    postUrlencodedData(api.deleteNews(id))
        .then(res => {
            if (res.code === 200)
                callBack(true);
            else
                callBack(false, res.message);
        }, rej => {
            console.log(rej);
            callBack(false)
        });
}

export function updateNews(data, callBack){
    postUrlencodedData(api.updateNews(data.id), data)
        .then(res => {
            if (res.code === 200)
                callBack(true);
            else
                callBack(false, res.message);
        }, rej => {
            console.log(rej);
            callBack(false)
        });
}

export function getNewsDetail(id, callBack) {
    getData(api.getNews(id))
        .then(res => {
            if (res.code === 200)
                callBack(res.data);
            else
                callBack(false, res.message);
        }, rej => {
            console.log(rej);
            callBack(false)
        });
}

export function addNews(data, callBack) {
    postUrlencodedData(api.addNews, data)
        .then(res => {
            if (res.code === 200)
                callBack(true);
            else
                callBack(false, res.message);
        }, rej => {
            console.log(rej);
            callBack(false)
        });
}
